import {ResponseData} from '@dvrd/fetch';
import {ContentMode, Language} from './enums';
import {updateContent as updateRequest} from './requestSender';
import {ContentDef} from './types';

export function updateContent(content: ContentDef, language: Language, contentMode: ContentMode, callback?: (data: ResponseData, response: Response) => void) {
    updateRequest({
        data: {content, language, content_mode: contentMode}, callback: (data: ResponseData, response: Response) => {
            callback?.(data, response);
        }
    });
}